import React, { useState } from 'react';

const AbaDadosPessoais = () => {
  const [nome, setNome] = useState('');
  const [cpf, setCpf] = useState('');
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Dados enviados com sucesso!');
  };

  return (
    <div className="form-section">
      <h2 className="form-title">Atualize seus dados pessoais</h2>

      <form onSubmit={handleSubmit} className="form-fields">
        <div className="input-group">
          <input
            type="text"
            placeholder="Nome completo"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            className="form-input"
          />
          <input
            type="text"
            placeholder="CPF"
            value={cpf}
            onChange={(e) => setCpf(e.target.value)}
            className="form-input"
          />
          <input
            type="email"
            placeholder="E-mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="form-input"
          />
        </div>
        <button type="submit" className="submit-button">Salvar dados</button>
      </form>
    </div>
  );
};

export default AbaDadosPessoais;
